class ResponsiveClass {
	MOBILE_MAX_WIDTH = 900
	SMALL_MAX_WIDTH = 1200
	SMALL_MIN_WIDTH = 900

	isSmaller = $state(false) // (max-width: 1200px) and (min-width: 900px)
	isMobile = $state(false)

	// Definite-assignment (`!`) rather than `| undefined`, because on the server
	// these are never assigned AND never read. The constructor bails before
	// checkMobile() when there is no `window`, and the only two readers —
	// checkMobile (which assigns first) and setupMediaQueryListener (called by
	// the constructor immediately after checkMobile) — are both inside that
	// browser-only path. Every read is therefore preceded by its assignment.
	//
	// Widening to `MediaQueryList | undefined` and optional-chaining the reads
	// would change behaviour: `this.mobileMediaQuery?.matches` is `undefined`,
	// so `isMobile`/`isSmaller` would flip from `false` to `undefined` for every
	// consumer. `!` erases at compile time and emits identical JavaScript.
	private mobileMediaQuery!: MediaQueryList
	private smallMediaQuery!: MediaQueryList

	constructor() {
		if (typeof window === "undefined") return

		this.checkMobile()
		this.setupMediaQueryListener()
	}

	private checkMobile() {
		this.mobileMediaQuery = window.matchMedia(`(max-width: ${this.MOBILE_MAX_WIDTH}px)`)
		this.isMobile = this.mobileMediaQuery.matches

		this.smallMediaQuery = window.matchMedia(
			`(max-width: ${this.SMALL_MAX_WIDTH}px) and (min-width: ${this.SMALL_MIN_WIDTH}px)`,
		)
		this.isSmaller = this.smallMediaQuery.matches
	}

	private setupMediaQueryListener() {
		const update = () => {
			this.isMobile = this.mobileMediaQuery.matches
			this.isSmaller = this.smallMediaQuery.matches
		}
		this.mobileMediaQuery.addEventListener("change", update)
		this.smallMediaQuery.addEventListener("change", update)
	}
}

export const Responsive = new ResponsiveClass()
